import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BRAND_VOICE } from './schema';

const QUERY = gql`
  query BrandVoice($id: ID!) {
    brandVoice(id: $id) {
      ...BrandVoice
    }
  }
  ${FRAGMENT_BRAND_VOICE}
`;

export const queryBrandVoice = async (id) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { id },
  });
  return getSingleProp(result.data);
};
